/**
 * Created by lihanying on 2017/6/26.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Stream from './component/stream'

class StreamList extends React.Component {
  static defaultProps = {
    streamList: [],
    walletList: {
      list: [],
    },
  }

  render() {
    const { streamList, walletList } = this.props
    return (
      <Stream
        list={streamList}
        walletList={walletList}
        fetchClubSearchStream={this.props.fetchClubSearchStream}
        fetchClubWalletList={this.props.fetchClubWalletList}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    streamList: state.getClubStream.streamList,
    walletList: state.getClubStream.walletList,
  }
}
export default withRouter(connect(mapStateToProps, actions)(StreamList))



// WEBPACK FOOTER //
// ./src/containers/ClubStream/index.js